import FlashAlert from './FlashAlert';

export default FlashAlert;
